
import { Component, Vue } from 'vue-property-decorator'
import axios from 'axios'
import { message, Modal } from 'ant-design-vue'
import Company from '@/types/company'
import { can } from '@/globalFunctions'

@Component
export default class ProjectSuppliersTab extends Vue {
  loading = { suppliers: false, companies: false }
  saving = false
  deleting = false
  showModal = false
  editing = false
  contractNumbers:string[] = []
  hoveredSupplierId:number|null = null
  suppliers:(Company & { contract_numbers:string[] })[] = []
  search = ''
  companies:Company[] = []
  companyId:number|null = null

  get canEdit () : boolean {
    return can('projects.edit')
  }

  get canEditContractNumbers () : boolean {
    return this.$store.getters['authStore/hasRole']('developer') || (this.canEdit && this.$store.getters.currentProject.in_afas === false)
  }

  get supplierIds () : number[] {
    return this.suppliers.map((s:Company) => s.id)
  }

  get filteredSuppliers () : (Company & { contract_numbers:string[] })[] {
    const query = this.search.trim().toLowerCase()
    if (!query) return this.suppliers

    return this.suppliers.filter(supplier => supplier.name.toLowerCase().includes(query) || supplier.contract_numbers.some(number => number.toLowerCase().includes(query)))
  }

  mounted () : void {
    this.getSuppliers()
    this.getCompanies()
  }

  getSuppliers () : void {
    this.loading.suppliers = true
    axios.get(process.env.VUE_APP_API_URL + '/projects/' + this.$route.params.projectId + '/suppliers').then((r) => {
      this.suppliers = r.data.data
    }).finally(() => {
      this.loading.suppliers = false
    })
  }

  getCompanies () : void {
    this.loading.companies = true
    axios.get(process.env.VUE_APP_API_URL + '/companies?filter[active]=1&sort=name&limit=5000').then((r) => {
      this.companies = r.data.data
    }).finally(() => {
      this.loading.companies = false
    })
  }

  store () : void {
    if (!this.companyId) return

    this.saving = true
    const data = this.canEditContractNumbers ? { contract_numbers: [...new Set(this.contractNumbers.map((number) => number.trim()).filter((number) => number !== ''))] } : {}
    const request = this.editing ? axios.put : axios.post
    request(process.env.VUE_APP_API_URL + '/projects/' + this.$route.params.projectId + '/suppliers/' + this.companyId, data).then((r) => {
      this.suppliers = r.data.data
      message.success(this.editing ? 'Leverancier succesvol bijgewerkt.' : 'Leverancier succesvol toegevoegd.')
      this.toggleModal()
    }).finally(() => {
      this.saving = false
    })
  }

  confirmDestroy (supplier:Company) : void {
    Modal.confirm({
      title: 'Weet je zeker dat je onderstaand item wilt verwijderen?',
      content: supplier.name || '-',
      okText: 'Ja, verwijderen',
      okType: 'danger',
      cancelText: 'Nee, annuleren',
      width: '35%',
      onOk: () => {
        this.destroy(supplier.id)
      }
    })
  }

  destroy (companyId:number) : void {
    this.deleting = true
    axios.delete(process.env.VUE_APP_API_URL + '/projects/' + this.$route.params.projectId + '/suppliers/' + companyId).then((r) => {
      this.suppliers = r.data.data
      message.success('Leverancier succesvol verwijderd.')
    }).finally(() => {
      this.deleting = false
    })
  }

  toggleModal (supplier?:Company & { contract_numbers:string[] }) : void {
    this.showModal = !this.showModal
    this.editing = !!supplier
    this.companyId = supplier?.id || null
    this.contractNumbers = [...(supplier?.contract_numbers || [])]
  }

  filterOptions (input:string, option:{componentOptions:{children:{text:string}[]}}) : boolean {
    return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
  }
}
